import { BASE_URL } from '@constants/api'
import { ListLeadRequest, ListLeadResponse } from '@models/leads.model'
import {
	ListSignupRequest,
	ListSignupResponse,
	SignupFilter,
} from '@models/signups.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

// Parâmetro vazio não pode ir na URL: `startDate=` derruba o validator de data da API.
function signupFilterParams(range: SignupFilter) {
	const params = new URLSearchParams({ status: range.status })

	if (range.period) params.set('period', range.period)
	if (range.startDate) params.set('startDate', range.startDate)
	if (range.endDate) params.set('endDate', range.endDate)

	return params.toString()
}

export const leadApi = createApi({
	reducerPath: 'leadApi',
	tagTypes: ['Usuarios', 'Usuario', 'LeadsPopups', 'Cadastros'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		list: builder.query<ListLeadResponse, ListLeadRequest>({
			query: ({ page, startDate, endDate }) => ({
				url: `/leads?limit=20&page=${page}&startDate=${startDate}&endDate=${endDate}`,
				method: 'GET',
			}),
			providesTags: ['Usuarios'],
		}),
		listSignups: builder.query<ListSignupResponse, ListSignupRequest>({
			query: ({ page, ...range }) => ({
				url: `/signups?limit=20&page=${page}&${signupFilterParams(range)}`,
				method: 'GET',
			}),
			providesTags: ['Cadastros'],
		}),
		exportSignups: builder.mutation<Blob, SignupFilter>({
			query: (range) => ({
				url: `/signups/export?${signupFilterParams(range)}`,
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		listLeadsPopups: builder.query<
			ListLeadResponse,
			{ page: number; startDate?: string; endDate?: string; popupId?: string }
		>({
			query: ({ page, startDate, endDate, popupId }) => ({
				url: `/popup-trackings/?page=${page}&startDate=${
					startDate || ''
				}&endDate=${endDate || ''}&popupId=${popupId || ''}`,
				method: 'GET',
			}),
			providesTags: ['LeadsPopups'],
		}),
		exportLeadsPopups: builder.mutation<
			Blob,
			{ startDate: string; endDate: string }
		>({
			query: ({ startDate, endDate }) => ({
				url: `/popup-trackings/export/?startDate=${startDate}&endDate=${endDate}`,
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		show: builder.mutation<{ id: string }, { id: string }>({
			query: ({ id }) => ({
				url: `/admins/${id}`,
				method: 'GET',
			}),
		}),
	}),
})

export const {
	useListQuery,
	useShowMutation,
	useExportLeadsPopupsMutation,
	useListSignupsQuery,
	useExportSignupsMutation,
} = leadApi
